export default __webpack_public_path__ + "static/media/purple-heart.f9c387fc.svg";